<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="2 2 20 20">
    <path d="M 14.6,16.6L 19.2,12L 14.6,7.4L 16,6L 22,12L 16,18L 14.6,16.6 Z M 9.4,16.6L 4.8,12L 9.4,7.4L 8,6L 2,12L 8,18L 9.4,16.6 Z "/>
  </svg>
</template>
